import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import gridSvg from "../../assets/image/grid.svg";

const ShowAttributeExpertRequestDetail = ({ data }) => {
  const navigate = useNavigate();
  const params = useParams();
  const pathname = useLocation();

  const clickHandler = () => {
    if (
      pathname?.pathname.startsWith("/view-attribute-group-expert-request/")
    ) {
      navigate(
        `/view-attribute-group-expert-request/edit/${data.id}/${params.id}?loc=url`,
      );
    }
  };
  return (
    <div
      className={
        "shadow-[0px_0_5px_2px_#00000024] rounded-[8px] flex flex-col items-center gap-2 py-5 cursor-pointer hover:bg-stone-100 relative"
      }
      onClick={clickHandler}
    >
      <img src={gridSvg} alt="erorr500" className="w-[40px] m-auto" />
      <span className={"text-[14px]"}>{data.name}</span>
      {/*<div className="absolute top-1 left-1">*/}
      {/*  <CircleProgress value={data?.percentage_of_completion} />*/}
      {/*</div>*/}
    </div>
  );
};

export default ShowAttributeExpertRequestDetail;
